import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiSearchparticipantCodeVerificationMutationRequest,
  PostApiSearchparticipantCodeVerificationMutationResponse,
} from "../../../types/PostApiSearchparticipantCodeVerification";

export function getPostApiSearchparticipantCodeVerificationUrl() {
  return `/api/SearchParticipant/code-verification` as const;
}

/**
 * {@link /api/SearchParticipant/code-verification}
 */
export async function postApiSearchparticipantCodeVerification(
  data?: PostApiSearchparticipantCodeVerificationMutationRequest,
  config: Partial<
    RequestConfig<PostApiSearchparticipantCodeVerificationMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiSearchparticipantCodeVerificationMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiSearchparticipantCodeVerificationMutationRequest
  >({
    method: "POST",
    url: getPostApiSearchparticipantCodeVerificationUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
